import { render, staticRenderFns } from "./addEditDialog.vue?vue&type=template&id=24b1150c&scoped=true"
import script from "./addEditDialog.vue?vue&type=script&lang=js"
export * from "./addEditDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditDialog.vue?vue&type=style&index=0&id=24b1150c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b1150c",
  null
  
)

export default component.exports